import { render, staticRenderFns } from "./CourseDescriptionText.vue?vue&type=template&id=6a13b3d7&scoped=true"
var script = {}
import style0 from "./CourseDescriptionText.vue?vue&type=style&index=0&id=6a13b3d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a13b3d7",
  null
  
)

export default component.exports